export { default } from './LastTwelveWeeks';
export type { LastTwelveWeeksProps } from './LastTwelveWeeks.types';
